import type { AlarmContacts } from "@visioni/a3s-alarm-schedules/schema";
import { useUpdateCameraContacts } from "@src/services/api/hooks";
import { useTenantId } from "@src/features/tenants";

export type SubmitSmsCallbacks = {
  onSuccess: () => void;
  onError: (error: { message: string }) => void;
};

export type SubmitSmsParams = {
  name: string;
  phone_number: string;
};

export type SmsContactSubmitOptions = {
  siteId?: string;
  cameraKey?: string;
  cameraContacts?: AlarmContacts | null;
};

export function useSmsContactSubmit(options: SmsContactSubmitOptions) {
  const tenantId = useTenantId();
  const updateCameraContactsMutation = useUpdateCameraContacts();

  const hasCameraContext = Boolean(tenantId && options.siteId && options.cameraKey);

  const submitSms = (params: SubmitSmsParams, callbacks: SubmitSmsCallbacks) => {
    const { name, phone_number } = params;

    if (!hasCameraContext) {
      console.error("useSmsContactSubmit called without tenantId/siteId/cameraKey");
      return;
    }

    const current: AlarmContacts = options.cameraContacts ?? {
      sms_contacts: [],
      email_contacts: [],
    };

    const next: AlarmContacts = {
      ...current,
      sms_contacts: [
        ...current.sms_contacts,
        {
          name,
          phone_number,
        },
      ],
    };

    updateCameraContactsMutation.mutate(
      {
        siteId: options.siteId!,
        cameraKey: options.cameraKey!,
        contacts: next,
      },
      {
        onSuccess: callbacks.onSuccess,
        onError: callbacks.onError,
      },
    );
  };

  return {
    submitSms,
    isSubmitting: updateCameraContactsMutation.isPending,
  };
}
